import type { ReactNode } from "react";

export interface SectionProps {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
}

export const Section = ({ title, defaultOpen = true, children }: SectionProps) => (
  <details className="section" open={defaultOpen}>
    <summary className="section-title">{title}</summary>
    {children}
  </details>
);
